export default {
  getProductList: (rowIndex, pageSize) =>
    `/mock/products/likes.json?rowIndex=${rowIndex}&pageSize=${pageSize}`,
  login: () => '/Handler/Manager.ashx?type=login&xtype=zg'
};
